var map = {
	"./annotated": 159,
	"./annotated.js": 159,
	"./base": 77,
	"./base.js": 77,
	"./console": 207,
	"./console.js": 207,
	"./html": 160,
	"./html.js": 160,
	"./index": 161,
	"./index.js": 161,
	"./jsonpatch": 162,
	"./jsonpatch.js": 162
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1399;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src/formatters ^\.\/.*$
 ** module id = 1399
 ** module chunks = 0
 **/